const apis = {
  fileGet: 'GET /api/twin/v1/file',
  fileUploadPost: 'POST /api/twin/v1/file/upload',
  fileMultipartInitPost: 'POST /api/twin/v1/file/multipart/init',
  fileMultipartUploadPost: 'POST /api/twin/v1/file/multipart/upload',
  fileMultipartCompletePost: 'POST /api/twin/v1/file/multipart/complete',
  fileMultipartAbortPost: 'POST /api/twin/v1/file/multipart/abort',
  fileModelPacketInitPost: 'POST /api/twin/v1/file/model-packet/init',
  fileModelPacketUploadPost: 'POST /api/twin/v1/file/model-packet/upload',
  fileModelPacketCompletePost: 'POST /api/twin/v1/file/model-packet/complete',
  fileModelPacketAbortPost: 'POST /api/twin/v1/file/model-packet/abort',
  fileHandlesGet: 'GET /api/twin/v1/file/handles',
  fileHandlesPost: 'POST /api/twin/v1/file/handles',
  fileHandlesDelete: 'DELETE /api/twin/v1/file/handles',
  assetsGet: 'GET /api/twin/v1/assets',
  assetsPost: 'POST /api/twin/v1/assets',
  assetsPatch: 'PATCH /api/twin/v1/assets',
  assetsFontsGet: 'GET /api/twin/v1/assets/fonts',
  assetsAllGet: 'GET /api/twin/v1/assets/all',
  assetGet: 'GET /api/twin/v1/assets/{id}',
  assetPatch: 'PATCH /api/twin/v1/assets/{id}',
  assetDelete: 'DELETE /api/twin/v1/assets/{id}',
  assetCategoriesGet: 'GET /api/twin/v1/asset-categories',
  assetCategoriesPost: 'POST /api/twin/v1/asset-categories',
  assetCategoriePatch: 'PATCH /api/twin/v1/asset-categories/{id}',
  assetCategorieDelete: 'DELETE /api/twin/v1/asset-categories/{id}',
  projectsGet: 'GET /api/twin/v1/projects',
  projectsDelete: 'DELETE /api/twin/v1/projects',
  projectsPost: 'POST /api/twin/v1/projects',
  projectsCountGet: 'GET /api/twin/v1/projects/count',
  projectsVideoProjectsGet: 'GET /api/twin/v1/projects/video-projects',
  projectGet: 'GET /api/twin/v1/projects/{id}',
  projectPatch: 'PATCH /api/twin/v1/projects/{id}',
  projectsRecoverPatch: 'PATCH /api/twin/v1/projects/{id}/recover',
  projectsCopyPost: 'POST /api/twin/v1/projects/{id}/copy',
  projectsImportPost: 'POST /api/twin/v1/projects/import',
  projectsExportGet: 'GET /api/twin/v1/projects/{id}/export',
  projectsTemporarySynchronizationCodeGet:
    'GET /api/twin/v1/projects/{id}/temporary/synchronization-code',
  projectsSynchronizePost: 'POST /api/twin/v1/projects/synchronize',
  projectsSynchronizationCodePost: 'POST /api/twin/v1/projects/{id}/synchronization-code',
  projectGroupsGet: 'GET /api/twin/v1/project-groups',
  projectGroupsPost: 'POST /api/twin/v1/project-groups',
  projectGroupsPatch: 'PATCH /api/twin/v1/project-groups',
  projectGroupPatch: 'PATCH /api/twin/v1/project-groups/{id}',
  projectGroupDelete: 'DELETE /api/twin/v1/project-groups/{id}',
  projectsScenesGet: 'GET /api/twin/v1/projects/{projectId}/scenes',
  projectsScenePatch: 'PATCH /api/twin/v1/projects/scenes/{id}',
  scenesObjsHierarchyPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/hierarchy',
  scenesObjsHierarchyConfigPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/hierarchy/config',
  scenesObjsGet: 'GET /api/twin/v1/scenes/{sceneId}/objs',
  scenesObjsPost: 'POST /api/twin/v1/scenes/{sceneId}/objs',
  scenesObjsPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs',
  scenesObjsDeletedGet: 'GET /api/twin/v1/scenes/{sceneId}/objs/deleted',
  scenesObjGet: 'GET /api/twin/v1/scenes/{sceneId}/objs/{id}',
  scenesObjPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/{id}',
  scenesObjsGatherPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/gather',
  scenesObjsRecoverPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/recover',
  scenesObjsRemovePost: 'POST /api/twin/v1/scenes/{sceneId}/objs/remove',
  scenesObjsCopyPost: 'POST /api/twin/v1/scenes/{sceneId}/objs/copy',
  scenesObjsSplitPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/split',
  scenesObjsComponentsStatesPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states',
  scenesObjsComponentsVersionsPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/versions',
  scenesObjsVideoProjectPost: 'POST /api/twin/v1/scenes/{sceneId}/objs/video-project',
  scenesObjsComponentsRelsGet:
    'GET /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels',
  spaceGet: 'GET /api/twin/v1/space',
  usersMeGet: 'GET /api/twin/v1/users/me',
  resourceResourceCategoryGet: 'GET /api/twin/v1/resource/resource-category',
  resourceStaticMaterialGet: 'GET /api/twin/v1/resource/static-material',
  resourceGet: 'GET /api/twin/v1/resource',
  resourcePost: 'POST /api/twin/v1/resource',
  resourceDelete: 'DELETE /api/twin/v1/resource',
  resourcePatch: 'PATCH /api/twin/v1/resource/{id}',
  officialResourcesGet: 'GET /api/twin/v1/official-resources',
  officialResourcesPost: 'POST /api/twin/v1/official-resources',
  officialResourcesDelete: 'DELETE /api/twin/v1/official-resources',
  officialResourcesCategoryGet: 'GET /api/twin/v1/official-resources/category',
  officialResourcesCategoryPost: 'POST /api/twin/v1/official-resources/category',
  officialResourcesCategoryDelete: 'DELETE /api/twin/v1/official-resources/category',
  officialResourcesAllGet: 'GET /api/twin/v1/official-resources/all',
  officialResourcePatch: 'PATCH /api/twin/v1/official-resources/{id}',
  officialResourcesCategoryPatch: 'PATCH /api/twin/v1/official-resources/category/{id}',
  scenesResourcesGet: 'GET /api/twin/v1/scenes/{sceneId}/resources',
  scenesResourcesPost: 'POST /api/twin/v1/scenes/{sceneId}/resources',
  scenesResourcesPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/resources',
  scenesResourcePost: 'POST /api/twin/v1/scenes/{sceneId}/resource',
  scenesResourcePatch: 'PATCH /api/twin/v1/scenes/{sceneId}/resources/{id}',
  scenesRemoveResourcesPost: 'POST /api/twin/v1/scenes/{sceneId}/remove/resources',
  shareProjectGet: 'GET /api/twin/v1/share/projects/{projectId}',
  shareProjectsSceneGet: 'GET /api/twin/v1/share/projects/{projectId}/scenes/{sceneId}',
  scenesObjsComponentsGet: 'GET /api/twin/v1/scenes/{sceneId}/objs/{objId}/components',
  scenesObjsComponentsPost: 'POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components',
  scenesObjsComponentsPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components',
  scenesObjsComponentsDelete: 'DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components',
  scenesObjsComponentsRelsPost:
    'POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels',
  scenesObjsComponentsRelsPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels',
  scenesObjsComponentsRelsDelete:
    'DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels',
  scenesObjsReplaceComponentsPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/replace/components',
  scenesObjsComponentPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}',
  scenesObjsComponentsVersionPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/version',
  scenesObjsComponentsSortPatch: 'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/sort',
  scenesObjsComponentsStatesSortPatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states/sort',
  scenesObjsComponentsStatePatch:
    'PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states/{id}',
  scenesObjsComponentsStatesPost:
    'POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states',
  scenesObjsComponentsStatesDelete:
    'DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states',
  customComponentsGet: 'GET /api/twin/v1/custom/components',
  customComponentsPost: 'POST /api/twin/v1/custom/components',
  customComponentDelete: 'DELETE /api/twin/v1/custom/components/{id}',
} as const;

export default apis;
